// 📁 src/utils/paymentMocks.js

export const fakeCardPaymentAPI = async ({
  cardholder,
  cardNumber,
  expiry,
  cvv,
  amount,
  currency,
  billingCycle,
  discountRate,
  vatRate,
  selectedModules
}) => {
  console.log('Simulating card payment...', {
    cardholder,
    cardNumber,
    expiry,
    cvv,
    amount,
    currency,
    billingCycle,
    discountRate,
    vatRate,
    selectedModules
  });
  return { status: 'success' }; // or { status: 'failure', message: 'Card declined' }
};

export const fakeBkashOtpAPI = async (mobile) => {
  console.log('Sending OTP to', mobile);
  return { status: 'sent' }; // or { status: 'failure', message: 'Invalid number' }
};

export const fakeBkashPaymentAPI = async ({
  mobile,
  otp,
  amount,
  currency,
  billingCycle,
  discountRate,
  vatRate,
  selectedModules
}) => {
  console.log('Processing bKash payment...', {
    mobile,
    otp,
    amount,
    currency,
    billingCycle,
    discountRate,
    vatRate,
    selectedModules
  });
  return { status: 'success' }; // or { status: 'failure', message: 'OTP mismatch' }
};
